// wave slider

export default function Slider(){
    return(
        <div>
        </div>
    )
}